import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, unref as _unref, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-bianzu21 paused-triangle" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "playing-icon-box"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "playing-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/UI/PC_icon/living.gif" })
], -1)
const _hoisted_9 = {
  key: 1,
  class: "playing-icon-box"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "playing-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/icon/backplay_icon.png" })
], -1)
const _hoisted_11 = {
  key: 2,
  class: "hot-count-icon-box"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "hot-count-icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-yanjing1" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "left-icom-wrapper" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-bianzu7beifen1" })
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "right-icom-wrapper" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-bianzu71" })
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-guanbibeifen1" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "player-mask-item" }
const _hoisted_20 = {
  key: 0,
  class: "unplaying-center-box"
}
const _hoisted_21 = {
  key: 0,
  class: "go-appointment-container"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "unplaying-center-box unplaying-center-backplay-box"
}
const _hoisted_24 = { class: "go-appointment-container" }
const _hoisted_25 = { class: "go-appointment" }
const _hoisted_26 = { class: "live-title-box" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "blur-style-box" }, null, -1)
const _hoisted_28 = ["title"]
const _hoisted_29 = ["id"]

import { ref, onMounted, watch, onUnmounted } from 'vue'
import { t } from '@/plugins/i18n'
import { requestVideoReserve } from '@/apis/live'
import { getLiveDetailPageHref, showIfNeedMemberDialogForLive, ENUM_LIVE_STATUS } from './utils'
import { ActivityItem } from '../index.vue'
import router from '@/router'
import store, { useRtfix, useUser } from '@/store'
import dayjs from 'dayjs'
import { TaEvent, taTrack } from '@/util/buryingPoint'

export interface LiveCardProps {
  /** 播放容器id的前缀 */
  idPrefix: string;
  // /** 播放中 */
  // isPlaying: boolean;
  /** 预约 | 播放 */
  cardType: 'reserve' | 'play';
  /** 直播列表 */
  activities: ActivityItem[];
}

/**
 * 是否是会员
 */

export default /*#__PURE__*/_defineComponent({
  props: {
    idPrefix: { type: String, required: true },
    cardType: { type: String, required: true },
    activities: { type: Array, required: true }
  },
  setup(__props: any) {

const props = __props as {
  /** 播放容器id的前缀 */
  idPrefix: string;
  // /** 播放中 */
  // isPlaying: boolean;
  /** 预约 | 播放 */
  cardType: 'reserve' | 'play';
  /** 直播列表 */
  activities: ActivityItem[];
}
const getIsMember = () => {
  const membership = store.getters.membership
  const templateLevel = membership?.templateLevel ?? 0
  return templateLevel > 0
}


const isPlay = ref(true)
const carouselRef = ref()
const isHoverPlayer = ref(false)
const isMemberRef = ref(false)
const isClose = ref(false)
const webSDK: { current: any } = { current: null }

watch(isClose, (newIsClose) => {
  if (isClose.value === true) {
    webSDK.current?.destroy()
  }
})

onUnmounted(() => {
  isPlay.value = false
  webSDK.current?.destroy()
})
const getCountDownDateTime = (targetTimeStampMs: number) => {
  const curTimeStamp = new Date().getTime()
  const ms = targetTimeStampMs - curTimeStamp
  const leftTimeS = Math.floor(ms / 1000)
  if (ms <= 0) return [0, 0, 0, 0] as const
  const d = Math.floor(leftTimeS / (24 * 60 * 60))
  const h = Math.floor((leftTimeS / (60 * 60)) % 24)
  const m = Math.floor((leftTimeS / 60) % 60)
  const s = Math.floor(leftTimeS % 60)
  return [d, h, m, s] as const
}

const timemmm = new Date().getTime() + 1000 * 60 * 60 * 24 * 365

const currentIdxRef = ref<number>()

/**
 * 是否是直播中
 * @param activityStatus
 */
const getIsLiving = (activityStatus: ENUM_LIVE_STATUS) => {
  return activityStatus === ENUM_LIVE_STATUS.LIVING
}
/**
 * 是否是回放
 * @param activityStatus
 */
const getIsBackplay = (activityStatus: ENUM_LIVE_STATUS) => {
  return activityStatus === ENUM_LIVE_STATUS.BACKPLAY
}
const countDownNum = ref<ReturnType<typeof getCountDownDateTime>>([0, 0, 0, 0])
const jumpLivePage = () => {
  const index = currentIdxRef.value
  if (index === undefined) return
  if (showIfNeedMemberDialogForLive(showIfNeedMemberDialogForLiveOptions)) { return }
  const activityId = props.activities[index].activityId
  window.location.href = getLiveDetailPageHref(activityId)
  // 跳转到直播页时，暂停浮窗播放
  webSDK.current?.emit('player.pause')
}
const clickPlayerBg = jumpLivePage
const onClickPlayingBoxBg = jumpLivePage
let oldInterval: any
const showIfNeedMemberDialogForLiveOptions = {
  onOK: () => {
    router.push(useRtfix('VipLevel'))
  }
}
// 监听轮播变化的的时候展示对应的倒计时
watch(currentIdxRef, async (newQuestion, oldQuestion) => {
  oldInterval ?? clearInterval(oldInterval)
  console.log(currentIdxRef, 'currentIdxRef')
  if (
    currentIdxRef.value === undefined ||
    !props.activities.length ||
    props.activities[currentIdxRef.value!].cardType === 'play'
  ) { return }
  oldInterval = setInterval(() => {
    const countDownDateTime = getCountDownDateTime(
      Number(props.activities[currentIdxRef.value!].liveTime! ?? 0) * 1000
    )
    countDownNum.value = countDownDateTime
  }, 1000)
})
/** 去预约 */
const onClickGoToAappointment = async (activityItem: ActivityItem) => {
  if (showIfNeedMemberDialogForLive(showIfNeedMemberDialogForLiveOptions)) { return }
  window.location.href = getLiveDetailPageHref(activityItem.activityId)
}
const onClickClose = (e: any) => {
  isClose.value = true
}
const onClickExpand = jumpLivePage
let pauseTimer: any
// hoverPlayerMaskTouchTart
const carouselChange = (toIdx: number, fromIdx: number) => {
  if (pauseTimer) {
    webSDK?.current?.emit?.('player.pause')
    clearTimeout(pauseTimer)
  }
  const isMember = getIsMember()
  isMemberRef.value = isMember
  currentIdxRef.value = toIdx
  const curItem = props.activities[toIdx]
  const isBackplay = curItem?.status === 3
  if (!curItem || props.activities[currentIdxRef.value!].cardType === 'reserve' || isBackplay || !props.activities.length) { return }
  webSDK.current?.destroy()
  const _window: any = window
  const ByteLiveWebSDK = _window.ByteLiveWebSDK
  webSDK.current = new ByteLiveWebSDK({
    // activityId: 1772373774978072,
    activityId: curItem.activityId,
    token: curItem.token,
    // token: 'TFsNIs',
    service: 'testDemo',
    mode: 1,
    modules: [
      {
        id: props.idPrefix + 'sniff_live_player_' + toIdx,
        mode: 'player'
      }
    ],
    options: {
      videoFillMode: 'cover',
      purePlayer: true
    }
  })
  //  不是会员 或者 是回放
  if (!isMember || getIsBackplay(curItem.status)) {
    pauseTimer = setTimeout(() => {
      webSDK.current?.emit('player.pause')
      pauseTimer = undefined
    }, 2000)
  }
}
/**
 * format 时间
 * @param num
 */
const getBackpayTime = (num: number) => {
  const dateTime = dayjs(num * 1000)
  return {
    month: dateTime.format('M'),
    day: dateTime.format('D'),
    hour: dateTime.format('HH'),
    minute: dateTime.format('mm'),
    second: dateTime.format('ss')
  }
}
const gotoLine = () => window.open('https://lin.ee/9noQAY4')

onMounted(() => {
  // currentIdxRef.value = 0
  // carouselRef.value.setActiveItem(0)
  carouselChange(0, 0)
  oldInterval ?? clearInterval(oldInterval)
})
const clickLeft = () => {
  carouselRef.value.prev()
  if (props.activities[currentIdxRef.value!].cardType === 'reserve') return
  isPlay.value = true
  console.log(carouselRef)
}
const clickRight = () => {
  const xx = carouselRef.value.next()
  if (props.activities[currentIdxRef.value!].cardType === 'reserve') return
  isPlay.value = true
  console.log(carouselRef, xx)
}

watch(isPlay, () => {
  webSDK.current?.emit(isPlay.value === true ? 'player.play' : 'player.pause')
})

const clickPause = (event: MouseEvent) => {
  event.stopPropagation()
  isPlay.value = !isPlay.value
}

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (!!__props.activities?.length && isClose.value === false)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "live-window-box",
        onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (isHoverPlayer.value = true)),
        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (isHoverPlayer.value = false)),
        onClick: _cache[5] || (_cache[5] = () => {
      _unref(taTrack)({
        event: _unref(TaEvent).BTN_CLICK,
        value: {
          position: 'live_broadcast'
        }
      })
    })
      }, [
        _withDirectives(_createElementVNode("div", {
          class: "hover-player-mask",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onClickPlayingBoxBg) && _unref(onClickPlayingBoxBg)(...args)))
        }, [
          (__props.activities[currentIdxRef.value ?? 0]?.cardType === 'play' && isMemberRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isPlay.value === false)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "pause",
                      onClick: clickPause
                    }, _hoisted_3))
                  : _createCommentVNode("", true),
                (isPlay.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "pause",
                      onClick: clickPause
                    }, _hoisted_6))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, isHoverPlayer.value && getIsLiving(__props.activities[currentIdxRef.value ?? 0]?.status)]
        ]),
        (getIsLiving(__props.activities[currentIdxRef.value ?? 0]?.status))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(_unref(t)('直播中')), 1)
            ]))
          : _createCommentVNode("", true),
        (getIsBackplay(__props.activities[currentIdxRef.value ?? 0]?.status))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(_unref(t)('直播回放')), 1)
            ]))
          : _createCommentVNode("", true),
        (getIsLiving(__props.activities[currentIdxRef.value ?? 0]?.status))
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", null, _toDisplayString(__props.activities[currentIdxRef.value ?? 0]?.uv), 1)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "left",
          onClick: clickLeft
        }, _hoisted_14, 512), [
          [_vShow, __props.activities?.length > 1]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "right",
          onClick: clickRight
        }, _hoisted_16, 512), [
          [_vShow, __props.activities?.length > 1]
        ]),
        _withDirectives(_createElementVNode("span", {
          class: "iconfont icon-fangda2 iconfont-expand",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onClickExpand) && _unref(onClickExpand)(...args)))
        }, null, 512), [
          [_vShow, isHoverPlayer.value && getIsLiving(__props.activities[currentIdxRef.value ?? 0]?.status)]
        ]),
        _createElementVNode("div", {
          class: "close-icon",
          onClick: onClickClose
        }, _hoisted_18),
        _createVNode(_component_el_carousel, {
          "initial-index": 0,
          height: "180px",
          autoplay: false,
          arrow: "never",
          "indicator-position": "none",
          ref: (_value, _refs) => {
            _refs['carouselRef'] = _value
            carouselRef.value = _value
          },
          onChange: carouselChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.activities, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: item.activityId
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "player-bg",
                    style: _normalizeStyle(__props.activities[currentIdxRef.value ?? 0]?.cardType
            ? {
              'background-image': `url(${item.coverImage ?? item.coverImage
                })`,
            }
            : {}
          ),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(clickPlayerBg) && _unref(clickPlayerBg)(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      (__props.activities[currentIdxRef.value ?? 0]?.cardType === 'reserve')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", null, _toDisplayString(_unref(t)('距离开播还剩')), 1),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", null, _toDisplayString(countDownNum.value[0]), 1),
                              _createTextVNode(_toDisplayString(_unref(t)('天')) + " ", 1),
                              _createElementVNode("span", null, _toDisplayString(countDownNum.value[1]), 1),
                              _createTextVNode(_toDisplayString(_unref(t)('时')) + " ", 1),
                              _createElementVNode("span", null, _toDisplayString(countDownNum.value[2]), 1),
                              _createTextVNode(_toDisplayString(_unref(t)('分')) + " ", 1),
                              _createElementVNode("span", null, _toDisplayString(countDownNum.value[3]), 1),
                              _createTextVNode(_toDisplayString(_unref(t)('秒')), 1)
                            ]),
                            (item.reserveFlag !== 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("div", {
                                    class: "go-appointment",
                                    onClick: ($event: any) => (onClickGoToAappointment(item))
                                  }, _toDisplayString(_unref(t)('去预约')), 9, _hoisted_22)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (getIsBackplay(item.status))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", null, _toDisplayString(getBackpayTime(Number(item.liveTime)).month) + _toDisplayString(_unref(t)('月')) + _toDisplayString(getBackpayTime(Number(item.liveTime)).day) + _toDisplayString(_unref(t)('日')), 1),
                              _createElementVNode("span", null, _toDisplayString(getBackpayTime(Number(item.liveTime)).hour) + ":" + _toDisplayString(getBackpayTime(Number(item.liveTime)).minute) + ":" + _toDisplayString(getBackpayTime(Number(item.liveTime)).second), 1)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('观看回放')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", {
                          class: "live-title-text",
                          title: item.name
                        }, _toDisplayString(item.name), 9, _hoisted_28)
                      ]),
                      _createElementVNode("div", {
                        class: "sniff-live-player",
                        id: __props.idPrefix + 'sniff_live_player_' + index
                      }, null, 8, _hoisted_29)
                    ])
                  ], 4)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 512)
      ], 32))
    : _createCommentVNode("", true)
}
}

})